exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ProgressWidget {\n  margin: 2rem 0px; }\n\n#TableWidgetQuotations .el-tablo.project-box {\n  text-decoration: none; }\n  #TableWidgetQuotations .el-tablo.project-box:hover {\n    color: #047bf8; }\n\n#TableWidgetQuotations .el-tablo .value {\n  font-size: 0.9rem; }\n\n#TableWidgetQuotations .quotation-agent-business-name {\n  font-size: 0.75rem;\n  text-transform: none; }\n", ""]);

// exports
